
jQuery(document).ready(function($) {
    // Handle parent menu items with children
    $('.mobile-menu-tray .menu-item-has-children > a').on('click', function(e) {
        e.preventDefault();
        
        var $parentLi = $(this).parent();
        
        // Close other open submenus
        $('.mobile-menu-tray .menu-item-has-children').not($parentLi).removeClass('submenu-open');
        $('.mobile-menu-tray .menu-item-has-children').not($parentLi).find('.sub-menu').slideUp(200);
        
        // Toggle current submenu
        $parentLi.toggleClass('submenu-open');
        $parentLi.find('> .sub-menu').slideToggle(200);
    });
});